import * as Yup from "yup";

import { formatCurrency } from "../../../../../../../util";
import { REFUND_COMPARISON_TOLERANCE } from "./calculateRefundableReceiptAmount";

const REFUND_TRANSACTION_TYPE_ID = 9;

const toCurrencyCents = value =>
  Math.round((Number(value) + Number.EPSILON) * 100);

const buildTransactionAmountValidation = ({
  availableInvoiceBalance,
  currencyCode,
  payTypes,
  refundableReceiptAmount,
}) =>
  Yup.number()
    .when("typeId", {
      is: REFUND_TRANSACTION_TYPE_ID,
      then: schema =>
        schema
          .required("Enter a refund amount")
          .moreThan(0, "Refund amount must be greater than 0")
          .max(
            refundableReceiptAmount + REFUND_COMPARISON_TOLERANCE,
            `Refund cannot exceed the available receipt credit of ${formatCurrency(
              refundableReceiptAmount,
              currencyCode,
            )}`,
          ),
    })
    .when("typeId", {
      is: typeId =>
        typeId !== REFUND_TRANSACTION_TYPE_ID &&
        payTypes.some(
          payType =>
            payType.numberId === typeId &&
            payType.cd === -1 &&
            payType.receipt !== -1,
        ),
      then: schema =>
        schema.test(
          "within-invoice-balance",
          `Transaction cannot exceed the available invoice balance of ${formatCurrency(
            availableInvoiceBalance,
            currencyCode,
          )}`,
          value =>
            value === undefined ||
            value === null ||
            toCurrencyCents(value) <=
              toCurrencyCents(availableInvoiceBalance),
        ),
    });

export { buildTransactionAmountValidation };
